import React, { useState } from 'react';
import { 
  Typography, 
  TextField, 
  Button, 
  Box,
  Paper,
  CircularProgress,
  Container,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material';
import ReactMarkdown from 'react-markdown';


const SessionNoteSummarizer = () => {
  const [rawNotes, setRawNotes] = useState('');
  const [noteType, setNoteType] = useState('');
  const [templateStyle, setTemplateStyle] = useState('');
  const [summary, setSummary] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateSummary = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('/api/generateSessionSummary', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ rawNotes, noteType, templateStyle }),
      });
      if (!response.ok) {
        throw new Error('Failed to generate session summary');
      }
      const data = await response.json();
      setSummary(data.summary);
    } catch (error) {
      console.error('Error generating session summary:', error);
      setError('Failed to generate session summary. Please try again.');
    }
    setLoading(false);
  };

  return (
    <Container maxWidth="md">
      <Paper elevation={0} sx={{ p: 4, backgroundColor: 'white' }}>
        <Box sx={{ mb: 4 }}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Note Type</InputLabel>
            <Select
              value={noteType}
              label="Note Type"
              onChange={(e) => setNoteType(e.target.value)}
            >
              <MenuItem value="parent">Parent Session</MenuItem>
              <MenuItem value="learner">Learner Session</MenuItem>
              <MenuItem value="supervision">Supervision</MenuItem>
              <MenuItem value="team_meeting">Team Meeting</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Template Style</InputLabel>
            <Select
              value={templateStyle}
              label="Template Style"
              onChange={(e) => setTemplateStyle(e.target.value)}
            >
              <MenuItem value="standard">Standard</MenuItem>
              <MenuItem value="detailed">Detailed</MenuItem>
              <MenuItem value="concise">Concise</MenuItem>
              <MenuItem value="SOAP">SOAP</MenuItem>
              <MenuItem value="BIRP">BIRP</MenuItem>
              <MenuItem value="DAP">DAP</MenuItem>
              <MenuItem value="ABC">ABC</MenuItem>
            </Select>
          </FormControl>
          <TextField
            fullWidth
            multiline
            rows={6}
            value={rawNotes}
            onChange={(e) => setRawNotes(e.target.value)}
            placeholder="Enter your raw session notes or bullet points here..."
            variant="outlined"
            sx={{ mb: 2 }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={generateSummary}
            disabled={loading || !rawNotes || !noteType || !templateStyle}
          >
            Generate Summary
          </Button>
        </Box>
         {loading && <CircularProgress />}
        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}
        {summary && (
          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" gutterBottom>
              Generated Summary:
            </Typography>
            <Paper elevation={1} sx={{ p: 2, backgroundColor: '#f5f5f5' }}>
              <ReactMarkdown>{summary}</ReactMarkdown>
            </Paper>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default SessionNoteSummarizer;